export interface HttpError extends Partial<Error> {
  message: string;
  status: number;
  type: string;
}

export enum HttpErrorType {
  UnconfirmedIpAddress = "Unauthorized-UnconfirmedIpAddress",
}
